import { getSurveys } from '@/services/surveys-service/surveys-service';
import { SurveysFilters } from '@/services/surveys-service/surveys-service.types';
import { ReactQueryKeys } from '@/utils/react-query-keys';
import { useQuery } from '@tanstack/react-query';
import { OrderBy } from '../use-sort-and-pagination/use-sort-and-pagination.types';

interface SurveysFiltersProps {
  filtersParams: SurveysFilters;
  paginationParams: {
    sort_by?: string;
    order_by: OrderBy;
    page: number;
    items_per_page: number;
  };
}

export const useSurveys = ({ filtersParams, paginationParams }: SurveysFiltersProps) => {
  const {
    data: surveysData,
    error,
    isPending,
    refetch,
  } = useQuery({
    queryKey: ReactQueryKeys.SURVEYS({ ...filtersParams, ...paginationParams }),
    queryFn: () => getSurveys({ ...filtersParams, ...paginationParams }),
  });

  return { surveysData, error, isPending, refetch };
};
